import {getPageData} from "../../pageData"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import nextI18nextConfig from "../../next-i18next.config"
import MbpHead from "../../components/head/MbpHead"
import {useTranslation} from "next-i18next"
import Footer from "../../components/footer/Footer"
import fetchReviews from "../../fetch/FetchReviews"
import {fetchStrapiDataCollection} from "../../fetch/BuildTimeFetchStrapi"
import {getBikesVerticalFilters, getHorizontalCategoryFilters} from "../../postgres/selectHelpers/selectQuery"
import React from "react"
import BrandWorldContent from "../../components/brandWorld/BrandWorldContent"

type Props = {
	reviews: any[]
}
function BrandWorld({reviews}:Props) {
	const {t} = useTranslation()
	const title = t("MyBikePlan | Alle E-Bike Modelle | Auf Raten mit 0% Zins")
	const description = t("Möchtest Du ein E-Bike besitzen? Schaue unsere Auswahl an und bestelle jetzt Dein E-Bike für ab CHF 52 im Monat!")
	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
				<meta property="og:image"
					content={"/assets/images/favicon.png"}/>
			</MbpHead>
			<BrandWorldContent reviews={reviews} />
			<Footer />
		</>
	)
}

export async function getStaticPaths() {
	try {
		const germanStrapiContent: any = await fetchStrapiDataCollection([], "de")
		const frenchStrapiContent: any = await fetchStrapiDataCollection([], "fr")

		const germanBrandWorlds = germanStrapiContent?.data?.brand_worlds ?? []
		const frenchBrandWorlds = frenchStrapiContent?.data?.brand_worlds ?? []

		const frenchPaths = frenchBrandWorlds
			.filter(brandWorld => brandWorld?.attributes?.brandSlug)
			.map(brandWorld => ({
				params: {brand: brandWorld.attributes.brandSlug},
				locale: "fr"
			}))

		const germanPaths = germanBrandWorlds
			.filter(brandWorld => brandWorld?.attributes?.brandSlug)
			.map(brandWorld => ({
				params: {brand: brandWorld.attributes.brandSlug},
				locale: "de"
			}))

		return {paths: [...frenchPaths, ...germanPaths], fallback: "blocking"}
	} catch (error) {
		console.error("Error fetching static paths:", error)
		return {paths: [], fallback: "blocking"}
	}
}

export async function getStaticProps({locale, params}) {
	const data = await getPageData(locale)
	const brandWorlds = data?.strapiContent?.data?.brand_worlds
	const brandWorld = brandWorlds?.find(({attributes: world}) => world.brandSlug === params.brand)?.attributes
	const bikeFilters = await getBikesVerticalFilters(locale, null, params.brand)
	const horizontalBikesCategoryFilters = await getHorizontalCategoryFilters(locale, false, "use_in_horizontal_bar", params.brand)

	if (!brandWorld?.brandName) {
		return {
			redirect: {
				destination: `/404?status=unavailable_brand_world&slug=${params.brand}`,
				permanent: false
			}
		}
	}

	const brandWidgets = data?.strapiContent?.data?.premium_brand_widgets
	const reviews = fetchReviews()
	const allPremiumBrandsGoogleReviews = brandWidgets.reduce((acc, item) => {
		if (item?.attributes?.googleReviews && Array.isArray(item?.attributes?.googleReviews)) {
			return acc.concat(item?.attributes?.googleReviews)
		}

		return acc
	}, []) || []
	reviews.reviews = allPremiumBrandsGoogleReviews.concat(reviews?.reviews)
	return {
		props: {
			brandWorld,
			...data,
			bikeFilters,
			horizontalBikesCategoryFilters,
			reviews,
			// eslint-disable-next-line
			...(await serverSideTranslations(locale, ["common", "productDescrPage", "filters", "PDPTiles", "banners", "URL", "search", "sponsorship", "insurance"], nextI18nextConfig))
		}
	}
}

export default BrandWorld
